import React from 'react';

import { InboxItemsRequestsListQueryVariables, useInboxItemsRequestsListQuery } from 'src/api';

import { useFilterStorage, useSearch } from '../common';

export const useInboxItemsReportList = () => {
  const { searchValue } = useSearch();
  const { sortQueryVariable, paginationQueryVariables } = useFilterStorage();

  const queryVariables = React.useMemo<InboxItemsRequestsListQueryVariables>(
    () => ({
      searchValue,
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    }),
    [paginationQueryVariables, searchValue, sortQueryVariable],
  );

  const { data, loading } = useInboxItemsRequestsListQuery({
    variables: queryVariables,
    fetchPolicy: 'cache-first',
  });

  return {
    inboxItems: data?.getInboxItemsRequests.items ?? [],
    inboxItemsCount: data?.getInboxItemsRequests.count || 0,
    loading,
  };
};
